// @ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import html2canvas from "html2canvas";
import {
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import PropTypes from "prop-types";
import { SignatureConsent } from "./SignatureModal";

const fontNames = [
  "Dancing Script",
  "Grape Nuts",
  "Indie Flower",
  "Moon Dance",
  "Reenie Beanie",
];

export const SignatureDropdown = ({ fullName, onSave }) => {
  const [selectedFont, setSelectedFont] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const signatureRefs = useRef({});

  const handleSave = async () => {
    if (!selectedFont || !fullName) return;

    setIsGenerating(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 200));

      const el = signatureRefs.current[selectedFont];
      if (!el) return;
      const originalColor = el?.style?.color;
      el.style.padding = "0 1rem";
      el.style.color = "black";

      const canvas = await html2canvas(el, {
        scale: 2,
        backgroundColor: null,
        color: "#000",
        logging: false,
      });

      el.style.color = originalColor;
      el.style.padding = 0;

      const pngData = canvas.toDataURL("image/png");
      onSave({
        font: selectedFont,
        image: pngData,
        fullName,
      });
    } catch (error) {
      console.error("Error generating signature:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Box sx={{ color: "white", width: "100%" }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Select Signature Style
      </Typography>

      <RadioGroup
        value={selectedFont}
        onChange={(e) => setSelectedFont(e.target.value)}
        sx={{ mb: 3, width: "100%" }}
      >
        {fontNames.map((font) => (
          <Box
            key={font}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 1,
              p: 1,
              border: "1px solid rgba(255, 255, 255, 0.23)",
              borderRadius: 1,
            }}
          >
            <FormControlLabel
              value={font}
              control={
                <Radio
                  size="small"
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                    "&.Mui-checked": {
                      color: getCssVariableHandler({
                        variableName: "--primary-pink-hex",
                      }),
                    },
                  }}
                />
              }
              label=""
              sx={{ mr: 1 }}
            />
            <Typography
              sx={{
                fontFamily: font,
                color: "white",
                fontSize: "1rem",
                width: "auto",
                display: "inline-flex",
              }}
              ref={(el) => {
                if (el) signatureRefs.current[font] = el;
              }}
            >
              {fullName || "Your Name"}
            </Typography>
          </Box>
        ))}
      </RadioGroup>

      <SignatureConsent isChecked={isChecked} setIsChecked={setIsChecked} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Button
          onClick={handleSave}
          className={`btnPink ${!(selectedFont && fullName && isChecked) ? "sow-btn-disabled" : ""}`}
          sx={{
            ...(!(selectedFont && fullName && isChecked)
              ? { cursor: "not-allowed" }
              : {}),
          }}
        >
          {isGenerating ? "Generating Signature..." : "Save Signature"}
        </Button>
      </Box>
    </Box>
  );
};

SignatureDropdown.propTypes = {
  fullName: PropTypes.string,
  onSave: PropTypes.func,
};